import styled from '@mui/material/styles/styled';
import ListItem from '@mui/material/ListItem';

export const StyledListItem = styled(ListItem)({
  display: 'flex', 
  alignItems: 'center',
  justifyContent: 'space-between', 
  gap: '8px', 
  marginBottom: 16
});